import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { ReportsService } from 'src/app/_services/reports.service';
import { GlobalService } from 'src/app/_services/global.service';
import { BaseService } from 'src/app/_services/base.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';
import { formatDate } from '@angular/common';
import { Paginator } from 'primeng/paginator';

import { NgxSpinnerService } from 'ngx-spinner';
import { FilterServiceService } from 'src/app/_services/filter-service.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-inventory-report',
  templateUrl: './inventory-report.component.html',
  styleUrls: ['./inventory-report.component.scss']
})
export class InventoryReportComponent implements OnInit {
  columns: any = ['']
  connForm: FormGroup
  // locations: any = null
  departments: any = ''
  dataList: any = ''
  allGroupedDataList: any[] = []
  groupedDataList: any[] = []
  hasVariantGroups = false
  variantGroupKeys: string[] = []
  expandedProductGroups = new Set<string>()
  expandedProductTitles = new Set<string>()

  page = 0
  rows = 10
  first = 0
  totalRecords = 0

  //order
  orderParam = ''
  orderBy = ''

  dateRange: any = null
  searchText = ''
  lastSearchText = ''
  selectedLocation: any = null
  selectedDepartment: any = null
  display = false

  gProductId: any = null
  selectedRow: any

  colheader = [[
    'Location', 'Product', 'Barcode', 'Sku', 'Opening Qty', 'Transfer-Out', 'Transer In'
    , 'Damage', 'Sold', 'Closing', 'Qty. On Hand', 'Variance'
  ]];

  colflds = ['locationName', 'itemName', 'barcode', 'skuCode',
    'openingStock', 'transferOut', 'transerIn', 'damage',
    'usedSince', 'closingStock', 'computedStockInHand', 'variance'];

  csvcols = []
  exportColumns: any = ''
  isLoading = false
  skeletonRows: { index: number }[] = []

  _globals = GlobalService

  @ViewChild('p', { static: false }) paginator: Paginator;

  constructor(
    private fb: FormBuilder,
    private _bs: BaseService,
    private _reportService: ReportsService,
    private _spinner: NgxSpinnerService,
    private _router: Router,
    private _abd: AppBaseDataService,
    public _filterService: FilterServiceService,
  ) {
    this.csvcols = this._abd.makeCsvCols(this.colheader, this.colflds)
    this.exportColumns = this.csvcols.map(col => ({ title: col.header, dataKey: col.field }))
  }

  async ngOnInit() {
    this._globals.componentName = 'Overview'
    this.intitializeForm()
    this.setSkeletonRows()

    // if (!this._filterService.dateRange || this._filterService.dateRange.length < 1)
    //   this._filterService.initDates()

    // this._filterService.selectedLocation = this._abd.locations[0]
    // this._filterService.selectedCategory = this._abd.departments[0]
    // this.getDataList()
  }

  ngAfterViewInit() {
    let ti = null
    ti = setInterval(() => {
      let ppages = this._filterService.getPages(this._globals.componentName)
      if (ppages) {
        let lastpage = parseInt(ppages.page)
        if (lastpage < 0) lastpage = 0
        if (lastpage > 0) {
          this.page = lastpage
          this.first = lastpage * this.rows
        }
      }


      let filter = this._filterService.getFilters(this._globals.componentName)
      if (filter) {
        if (filter.searchText) this._filterService.searchText = filter.searchText
        const rr = this._abd.getProductSellTypeFilter(filter.selectedProductSellTypeFilter)
        if (filter.selectedProductSellTypeFilter) this._filterService.selectedProductSellTypeFilter = rr
        if (filter.startDate) this._filterService.dateRange[0] = new Date(filter.startDate)
        if (filter.endDate) this._filterService.dateRange[1] = new Date(filter.endDate)
        if (filter.selectedLocation) this._filterService.selectedLocation = filter.selectedLocation
      }

      let oorderby = this._filterService.getOrderby(this._globals.componentName)
      if (oorderby) {
        this.orderParam = oorderby.orderParam
        this.orderBy = oorderby.orderBy
      }

      this.getDataList()
      clearInterval(ti)
    }, 700);
  }

  ngOnDestroy() {
    this._globals.componentName = ''
  }
  intitializeForm() {
    this.connForm = this.fb.group({
      selectedLocation: [null],
      selectedDepartment: [null],
      to: [new Date()],
      from: [new Date()],
    })
  }

  getDataList() {
    let ti = null
    ti = setInterval(() => {
      //--
      this.setSkeletonRows()
      this.isLoading = true
      let params = new HttpParams();
      let qryParas = null
      if (this.orderParam && this.orderParam.length > 0) {
        qryParas = `?orderParam=${this.orderParam}&orderBy=${this.orderBy}`
        this._filterService.updateOrderby(this._globals.componentName, { orderParam: this.orderParam, orderBy: this.orderBy })
      }

      try {
        if (!this._filterService.dateRange[0] || !this._filterService.dateRange[0].getFullYear()) {
          this._filterService.dateRange[0] = (new Date(new Date().setDate(new Date().getDate() - 7)))
          this._filterService.dateRange[1] = (new Date())
        }
        if (!this._filterService.dateRange[1]) {
          this._filterService.dateRange[1] = this._filterService.dateRange[0]
        }
      } catch {
        this._filterService.dateRange = []
        this._filterService.dateRange[0] = (new Date(new Date().setDate(new Date().getDate() - 7)))
        this._filterService.dateRange[1] = (new Date())
      }

      params = params.append('startDate', formatDate(this._filterService.dateRange[0], 'MM/dd/yyyy', 'en-US'));
      params = params.append('endDate', formatDate(this._filterService.dateRange[1], 'MM/dd/yyyy', 'en-US'));

      if (this._abd.locations && this._filterService.selectedLocation)
        params = params.append('locationId', this._filterService.selectedLocation?.id?.toString())
      else if (this._abd.locations?.length > 0)
        params = params.append('locationId', this._abd.locations[0].id);

      let sellOnline = this._filterService.selectedProductSellTypeFilter?.id;
      if (sellOnline) {
        if (sellOnline == 1)
          params = params.append('sellOnline', 'true')
        else if (sellOnline == 2)
          params = params.append('sellOnline', 'false')
      } else { }

      this.page = this.page < 1 ? 0 : this.page
      this.rows = this.rows < 1 ? 10 : this.rows

      // Grouped UX should paginate by visible products, so we load all filtered SKU rows first.
      params = params.append('pageNo', '0');
      params = params.append('pageSize', '1000');

      if (this._filterService.searchText) params = params.append('filterValue', this._filterService.searchText);

      const outfilter = {
        startDate: this._filterService.dateRange[0],
        endDate: this._filterService.dateRange[1],
        searchText: this._filterService.searchText ? this._filterService.searchText : '',
        selectedProductSellTypeFilter: sellOnline,
        selectedLocation: this._filterService.selectedLocation,
      }

      this._filterService.updateFilters(this._globals.componentName, outfilter)
      this._filterService.updatePages(this._globals.componentName, { page: this.page, rows: this.rows })

      let url = environment.InventoryBaseURL + environment.GetStockStatusReportV3
      if (qryParas) url += qryParas

      this._abd.showSpinner()
      this.loadInventoryRows(url, params)
        .finally(() => {
          this._abd.hideSpinner()
          this.isLoading = false
        })
      //--
      clearInterval(ti)
    }, 200);
  }

  private async loadInventoryRows(url: string, baseParams: HttpParams): Promise<void> {
    try {
      const allRows = await this.fetchAllInventoryRows(url, baseParams)
      this.dataList = allRows.map((item: any) => ({
        ...item,
        computedStockInHand: this.getComputedQtyOnHand(item)
      }))

      this.rebuildGroupedRows()
      this.totalRecords = this.allGroupedDataList.filter((row: any) => row?._rowType === 'group').length
      if (this.totalRecords > 0 && this.page * this.rows >= this.totalRecords) {
        this.page = 0
      }
      this.first = this.page * this.rows
      this.updatePagedGroupedRows()
    } catch {
      this.dataList = []
      this.totalRecords = 0
      this.rebuildGroupedRows()
      this.updatePagedGroupedRows()
    }
  }

  private async fetchAllInventoryRows(url: string, seedParams: HttpParams): Promise<any[]> {
    const chunkSize = 1000
    const paramsWithoutPage = seedParams.delete('pageNo').delete('pageSize')
    const allRows: any[] = []
    let pageNo = 0
    let totalFromApi = Number.MAX_SAFE_INTEGER

    while (allRows.length < totalFromApi) {
      const pagedParams = paramsWithoutPage
        .append('pageNo', pageNo.toString())
        .append('pageSize', chunkSize.toString())

      const res: any = await firstValueFrom(this._bs.httpGetParams(url, pagedParams))
      if (!res?.success) {
        break
      }

      const rows = Array.isArray(res.data) ? res.data : []
      totalFromApi = Number(res.totalRecords ?? rows.length)
      allRows.push(...rows)

      if (rows.length < chunkSize) {
        break
      }

      pageNo += 1
    }

    return allRows
  }

  private setSkeletonRows(): void {
    const length = this.rows > 0 ? this.rows : 10
    this.skeletonRows = Array.from({ length }, (_, index) => ({ index }))
  }

  private getComputedQtyOnHand(item: any): number {
    const qtyOnHand = Number(item?.stockInHand ?? 0)
    return Number.isFinite(qtyOnHand) ? qtyOnHand : 0
  }

  toggleGroup(row: any, event: Event): void {
    event.stopPropagation()
    if (!row?._isVariant || !row?._groupKey) {
      return
    }

    if (this.expandedProductGroups.has(row._groupKey)) {
      this.expandedProductGroups.delete(row._groupKey)
    } else {
      this.expandedProductGroups.add(row._groupKey)
    }

    this.rebuildGroupedRows()
  }

  setAllGroupsExpanded(expanded: boolean): void {
    if (expanded) {
      this.expandedProductGroups = new Set(this.variantGroupKeys)
    } else {
      this.expandedProductGroups.clear()
    }

    this.rebuildGroupedRows()
  }

  get sourceSkuCount(): number {
    return Array.isArray(this.dataList) ? this.dataList.length : 0
  }

  get groupedProductCount(): number {
    if (!Array.isArray(this.groupedDataList) || this.groupedDataList.length === 0) {
      return 0
    }

    return this.groupedDataList.filter((row: any) => row?._rowType === 'group').length
  }

  get hiddenByGroupingCount(): number {
    return Math.max(this.sourceSkuCount - this.groupedProductCount, 0)
  }

  get groupedSummaryText(): string {
    if (this.totalRecords < 1) {
      return 'No grouped products found for selected filters.'
    }

    return `Showing ${this.groupedProductCount} grouped products on this page. Total grouped products: ${this.totalRecords}.`
  }

  get areAllVariantGroupsExpanded(): boolean {
    if (!this.hasVariantGroups || this.variantGroupKeys.length === 0) {
      return false
    }

    return this.variantGroupKeys.every((key) => this.expandedProductGroups.has(key))
  }

  private rebuildGroupedRows(): void {
    if (!Array.isArray(this.dataList) || this.dataList.length === 0) {
      this.allGroupedDataList = []
      this.groupedDataList = []
      this.hasVariantGroups = false
      this.variantGroupKeys = []
      this.expandedProductGroups.clear()
      return
    }

    const groups = new Map<string, any[]>()
    const order: string[] = []
    for (const item of this.dataList) {
      const key = this.getGroupKey(item)
      if (!groups.has(key)) {
        groups.set(key, [])
        order.push(key)
      }
      const groupItems = groups.get(key)
      if (groupItems) {
        groupItems.push(item)
      }
    }

    const nextVariantKeys: string[] = []
    const nextGroupedRows: any[] = []
    for (const key of order) {
      const groupItems = groups.get(key) || []
      if (groupItems.length === 0) {
        continue
      }

      const isVariant = groupItems.length > 1
      if (isVariant) {
        nextVariantKeys.push(key)
      }

      const sum = (field: string): number =>
        groupItems.reduce((acc: number, current: any) => acc + this.toNumber(current?.[field]), 0)

      const firstItem = groupItems[0]
      const isExpanded = isVariant && this.expandedProductGroups.has(key)
      nextGroupedRows.push({
        ...firstItem,
        itemName: this.getGroupDisplayName(String(firstItem?.itemName || ''), isVariant),
        _rowType: 'group',
        _groupKey: key,
        _isVariant: isVariant,
        _variantCount: groupItems.length,
        _isExpanded: isExpanded,
        openingStock: sum('openingStock'),
        purchase: sum('purchase'),
        transferOut: sum('transferOut'),
        transerIn: sum('transerIn'),
        damage: sum('damage'),
        usedSince: sum('usedSince'),
        closingStock: sum('closingStock'),
        computedStockInHand: sum('computedStockInHand')
      })

      if (isExpanded) {
        for (const variantItem of groupItems) {
          nextGroupedRows.push({
            ...variantItem,
            _rowType: 'item',
            _groupKey: key,
            _isVariant: true,
            _variantCount: groupItems.length,
            _isExpanded: true
          })
        }
      }
    }

    const variantKeySet = new Set(nextVariantKeys)
    this.expandedProductGroups = new Set(
      Array.from(this.expandedProductGroups).filter((key) => variantKeySet.has(key))
    )
    this.variantGroupKeys = nextVariantKeys
    this.hasVariantGroups = nextVariantKeys.length > 0
    this.allGroupedDataList = nextGroupedRows
    this.updatePagedGroupedRows()
  }

  private updatePagedGroupedRows(): void {
    const safeRows = this.rows > 0 ? this.rows : 10
    const start = (this.page > 0 ? this.page : 0) * safeRows
    const groupRows = Array.isArray(this.allGroupedDataList)
      ? this.allGroupedDataList.filter((row: any) => row?._rowType === 'group')
      : []

    const visibleGroups = groupRows.slice(start, start + safeRows)
    const visibleGroupKeys = new Set(visibleGroups.map((row: any) => row?._groupKey))

    const pagedRows: any[] = []
    for (const groupRow of visibleGroups) {
      pagedRows.push(groupRow)
      if (groupRow?._isVariant && this.expandedProductGroups.has(groupRow._groupKey)) {
        const children = this.allGroupedDataList.filter(
          (row: any) => row?._rowType === 'item' && row?._groupKey === groupRow._groupKey
        )
        pagedRows.push(...children)
      }
    }

    this.groupedDataList = pagedRows
    this.first = start

    // Keep expanded keys bounded to visible groups to avoid carrying stale expanded state between pages.
    this.expandedProductGroups = new Set(
      Array.from(this.expandedProductGroups).filter((key) => visibleGroupKeys.has(key) || this.variantGroupKeys.includes(key))
    )
  }

  private getGroupKey(item: any): string {
    const location = String(item?.locationName || '').trim().toLowerCase()
    const groupIdentifier = this.getGroupIdentifier(item)
    if (groupIdentifier) {
      return `${location}::id::${groupIdentifier}`
    }

    const nameStem = this.getProductNameStem(String(item?.itemName || ''))
    return `${location}::name::${nameStem}`
  }

  canToggleProductTitle(item: any): boolean {
    return String(item?.itemName || '').trim().length > 20
  }

  isProductTitleExpanded(item: any): boolean {
    return this.expandedProductTitles.has(this.getProductTitleKey(item))
  }

  getDisplayProductTitle(item: any): string {
    const fullTitle = String(item?.itemName || '').trim()
    if (!fullTitle) {
      return ''
    }

    if (this.isProductTitleExpanded(item) || fullTitle.length <= 20) {
      return fullTitle
    }

    return fullTitle.slice(0, 20)
  }

  formatQuantity(value: any): string {
    const numericValue = Number(value)
    if (!Number.isFinite(numericValue)) {
      return '0'
    }

    const hasDecimals = Math.abs(numericValue % 1) > 0
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    }).format(numericValue)
  }

  getGroupTextValue(item: any, field: string): string {
    if (item?._rowType === 'group' && item?._isVariant) {
      return ''
    }

    const value = String(item?.[field] ?? '').trim()
    return value
  }

  toggleProductTitle(item: any, event: Event): void {
    event.stopPropagation()
    if (!this.canToggleProductTitle(item)) {
      return
    }

    const key = this.getProductTitleKey(item)
    if (this.expandedProductTitles.has(key)) {
      this.expandedProductTitles.delete(key)
      return
    }

    this.expandedProductTitles.add(key)
  }

  private getGroupIdentifier(item: any): string {
    const keys = [
      'itemId',
      'ItemId',
      'itemsId',
      'ItemsId',
      'productId',
      'ProductId',
      'parentItemId',
      'ParentItemId',
      'parentId',
      'ParentId'
    ]

    for (const key of keys) {
      const raw = String(item?.[key] ?? '').trim().toLowerCase()
      if (raw) {
        return raw
      }
    }

    return ''
  }

  private getProductNameStem(name: string): string {
    const normalized = String(name || '').trim().toLowerCase()
    if (!normalized) {
      return 'unknown'
    }

    const separators = [' - ', ' | ', ' / ']
    for (const separator of separators) {
      if (normalized.includes(separator)) {
        const firstPart = normalized.split(separator)[0].trim()
        if (firstPart) {
          return firstPart
        }
      }
    }

    return normalized
  }

  private getGroupDisplayName(name: string, isVariant: boolean): string {
    const normalizedName = String(name || '').trim()
    if (!normalizedName) {
      return ''
    }

    if (!isVariant) {
      return normalizedName
    }

    const separators = [' - ', ' | ', ' / ']
    for (const separator of separators) {
      if (normalizedName.includes(separator)) {
        const firstPart = normalizedName.split(separator)[0].trim()
        if (firstPart) {
          return firstPart
        }
      }
    }

    return normalizedName
  }

  private getProductTitleKey(item: any): string {
    const groupKey = String(item?._groupKey || '')
    const skuId = String(item?.itemSkuId || item?.itemSKUId || '').trim()
    const sku = String(item?.skuCode || '').trim()
    const barcode = String(item?.barcode || '').trim()
    const title = String(item?.itemName || '').trim()
    return `${groupKey}::${skuId}::${sku}::${barcode}::${title}`
  }

  private toNumber(value: any): number {
    const numericValue = Number(value)
    return Number.isFinite(numericValue) ? numericValue : 0
  }

  onPageChange(e) {
    e.totalRecords = this.totalRecords
    this.rows = e.rows
    this.page = e.page
    this.first = e.first
    this._abd.setOptionToLocalStorage(this._globals.componentName, 'last-page', e.page)
    this._filterService.updatePages(this._globals.componentName, { page: this.page, rows: this.rows })
    this.updatePagedGroupedRows()
  }

  callbackFuncFromFilter(event) {
    this.getDataList()
  }

  filterButtonPressed() {
    this.page = 0
    this.paginator?.changePage(0)
    this.getDataList()
  }

  clearSearchText() {
    this.searchText = ''
    if (this.lastSearchText.length > 0) {
      this.lastSearchText = ''
      this.filterButtonPressed()
    }
  }

  searchTextSearch() {
    if (this.searchText.length < 1 && this.lastSearchText.length < 1) return
    if (this.searchText === this.lastSearchText) return

    this.lastSearchText = this.searchText
    this.filterButtonPressed()
  }

  exportExcel() {
    this._abd.exportExcel(this.dataList, this.colheader[0], this.colflds, 'Inventory Overview')
  }

  exportPdf() {
    this._abd.exportPdf(this.dataList, this.colheader, this.colflds, 'Inventory Overview', true)
  }

  onRowSelect(e) {
    this.gProductId = e.data.itemSkuId
  }

  onRowUnselect(e) { }

  customSort(e) {
    if (!e.sortField) return

    const last = this.orderParam

    switch (e.sortField) {
      case 'itemName':
        this.orderParam = 'title'
        break;
      case 'barcode':
        this.orderParam = 'Barcode'
        break;
      case 'skuCode':
        this.orderParam = 'SkuCode'
        break;
      // default:
      //   this.orderParam = ''
    }

    if (this.orderParam !== '') {
      this.orderBy = e.sortOrder == 1 ? 'asc' : 'desc'
      if (last !== this.orderParam) this.orderBy = 'asc'
      this.getDataList()
    }
  }


}
